import { render, staticRenderFns } from "./VideoIcon.vue?vue&type=template&id=cf51c4d8&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/vue-it-bigger/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf51c4d8')) {
      api.createRecord('cf51c4d8', component.options)
    } else {
      api.reload('cf51c4d8', component.options)
    }
    module.hot.accept("./VideoIcon.vue?vue&type=template&id=cf51c4d8&", function () {
      api.rerender('cf51c4d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VideoIcon.vue"
export default component.exports